<template>
  <div class="transformation-wrapper">
    <el-container>
      <el-header>
        <uiHeader />
      </el-header>
      <el-main>
        <div class="transfer-wrapper">
          <div
            style="
              background-color: #ffffff;
              position: relative;
              padding: 1rem 0.5rem 0.5rem 0.5rem;
              text-align: center;
            "
          >
            <span style="font-size: 1rem; font-weight: 500"
              >通道列表({{ sharePlatformId }})</span
            >
          </div>
          <div
            style="
              background-color: #ffffff;
              margin-bottom: 1rem;
              position: relative;
              padding: 0.5rem;
              text-align: left;
              margin-bottom: 10px;
              font-size: 14px;
            "
          >
            <el-button
              icon="el-icon-arrow-left"
              size="mini"
              style="margin-right: 1rem"
              type="primary"
              @click="backFn"
              >返回</el-button
            >
          </div>
          <div style="margin-top: 10px">
            <Transfer
              :options="list"
              :treeData="list"
              left-title="可选"
              right-title="已共享"
              :disabled="loading"
              @update="updateFn"
              @remove="removeFn"
            />
          </div>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import uiHeader from "./UiHeader.vue";
import Transfer from "./Transfer/index.vue";
export default {
  name: "",
  components: {
    uiHeader,
    Transfer,
  },
  data() {
    return {
      sharePlatformId: this.$route.params.sharePlatformId,
      loading: false,
      selectedIds: [],
      list: [],
    };
  },
  mounted() {
    // this.getShareList();
  },
  methods: {
    getShareList() {
      this.loading = true;
      this.$axios({
        method: "get",
        url: `/api/devices/query`,
        params: {
          // page: this.currentPage,
          // step: this.count,
          sharePlatformId: this.$route.params.sharePlatformId,
          token: this.$cookies.get("session").token,
        },
      })
        .then((res) => {
          if (res && res.data.code === 0) {
            const { devices = [] } = res.data.data;
            this.list = devices.map((el) => {
              return {
                ...el,
                label: el.name,
                value: el.deviceId,
              };
            });
            this.selectedIds = devices
              .map((item) => {
                if (item.isShared) {
                  return item.id;
                }
                return "";
              })
              .filter(Boolean);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    backFn() {
      history.back();
    },
    updateFn(value) {
      const temp = [];
      this.list.forEach((item) => {
        if (value.includes(item.deviceId)) {
          temp.push({
            shareGbCode: item.gbCode,
            deviceChannelId: this.$route.params.deviceChannelId || "",
            sharePlatformId: this.$route.params.sharePlatformId,
            shareName: item.name,
          });
        }
      });
      const params = {
        devices: temp,
      };
      console.log("updateFn", params);
    },
    removeFn(value) {
      console.log("removeFn", value);
    },
  },
};
</script>

<style scoped>
.transformation-wrapper {
  height: 100%;
  width: 100%;
}

.transfer-wrapper {
  background-color: #e9eef3;
}
</style>



// WEBPACK FOOTER //
// src/components/transformation.vue